// 邮寄信息管理
import {contractApi} from "@/axios";
//获取邮寄信息
export function getMailPage(params,data){
    return contractApi({
        url:'/mail-info/page',
        method:'post',
        data:data,
        params:params
    })
}
//删除邮寄信息
export function deleteMail(params){
    return contractApi({
        url:'/mail-info',
        method:'delete',
        params:params
    })
}
//添加邮寄信息
export function addMail(data){
    return contractApi({
        url:'/mail-info',
        method:'post',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//修改邮寄信息
export function editMail(data){
    return contractApi({
        url:'/mail-info',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//邮寄审核
export function auditMail(data){
    return contractApi({
        url:'/mail-info/audit',
        method:'put',
        data:data
    })
}
//下载附件
export function attachmentMail(id,annexType,fileName) {
    return contractApi({
        url: '/mail-info/attachment/' + id + '/' + annexType + (fileName ? '/' : '') + fileName,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//获取相关邮寄信息
export function getMailAudit(params){
    return contractApi({
        url:'/mail-info/get-mail-audit',
        method:'get',
        params:params
    })
}
//添加邮寄单号
export function addMailNumber(data){
    return contractApi({
        url:'/mail-info/add-mail-number',
        method:'put',
        data:data
    })
}
//取消邮寄
export function notMail(data){
    return contractApi({
        url:'/mail-info/not-mail',
        method:'put',
        data:data
    })
}
//上传扫描件
export function uploadScanning(data){
    return contractApi({
        url:'/mail-info/upload-scanning',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//导出邮寄信息
export function exportMail(data) {
    return contractApi({
        url: '/mail-info/export',
        method: 'post',
        data:data,
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//修改邮寄负责人
export function updateCharge(data) {
    return contractApi({
        url: '/mail-info/update-mail-charge',
        method: 'put',
        data: data
    })
}